import type { MediaRef } from '@site/shared'

export function mapMedia(
  raw: Record<string, unknown> | null | undefined,
  baseUrl: string,
): MediaRef | undefined {
  if (!raw || typeof raw !== 'object') return undefined
  const url = raw.url as string | undefined
  if (!url) return undefined
  return {
    id: String(raw.id ?? ''),
    url: url.startsWith('http') ? url : `${baseUrl}${url}`,
    alt: (raw.alt as string) ?? '',
    width: raw.width as number | undefined,
    height: raw.height as number | undefined,
  }
}
